module.exports = __webpack_public_path__ + "static/media/avatar_blowfish.79ede95e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/avatar_blowfish.png
// module id = 366
// module chunks = 0